import { useTheme } from '@mui/material';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';
import { FormField } from '../../../../components/FormField/FormField';
import { Multiselect } from '../../../../components/Multiselect/Multiselect';
import { UpdateUserSkeletonLoader } from '../../../../components/SkeletonLoader/UpdateUser.SkeletonLoader';
import { SelectItem, UserRole } from '../../../../types';
import { IUserFileds } from './UserModal';
import { useDeals } from '../../../../queries/hooks/useDeals';

export function DealOwnerFields() {
  const { colors } = useTheme();
  const { data: dealOptionsRaw, isLoading: dealOptionsLoading } = useDeals(false, UserRole.ADMIN);

  const { setFieldValue, values, touched, errors, setFieldTouched } =
    useFormikContext<IUserFileds>();
  const handleError = (field) => (touched[field] ? errors[field] : '');

  const dealsOptions: SelectItem[] = useMemo(() => {
    if (!dealOptionsRaw) return [];
    return dealOptionsRaw?.map((deal) => {
      return {
        ...deal,
        id: deal?.id,
        value: deal?.name || '',
      };
    });
  }, [dealOptionsRaw]);

  const labelStyle = {
    color: colors.text.caption,
  };

  const loadingFieldsOptions = dealOptionsLoading;

  return loadingFieldsOptions ? (
    <UpdateUserSkeletonLoader />
  ) : (
    <>
      <FormField
        label={'Deals (Optional)'}
        error={handleError('dealOwnerDeals')}
        labelStyle={labelStyle}
      >
        <Multiselect
          listboxStyle={{ height: '195px' }}
          options={dealsOptions}
          value={values?.dealOwnerDeals as SelectItem[]}
          onChange={(_, deals) => {
            setFieldValue('dealOwnerDeals', deals);
          }}
          onBlur={() => {
            setFieldTouched('dealOwnerDeals');
          }}
          disablePortal
          fieldPlaceholder='Select deals'
        />
      </FormField>
    </>
  );
}
